import { render, staticRenderFns } from "./outboundDetails.vue?vue&type=template&id=f0d79ace&scoped=true"
import script from "./outboundDetails.vue?vue&type=script&lang=js"
export * from "./outboundDetails.vue?vue&type=script&lang=js"
import style0 from "./outboundDetails.vue?vue&type=style&index=0&id=f0d79ace&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d79ace",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0d79ace')) {
      api.createRecord('f0d79ace', component.options)
    } else {
      api.reload('f0d79ace', component.options)
    }
    module.hot.accept("./outboundDetails.vue?vue&type=template&id=f0d79ace&scoped=true", function () {
      api.rerender('f0d79ace', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/call/page/outboundDetails.vue"
export default component.exports